import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row mb-25" }
const _hoisted_7 = { class: "col-md-3 col-sm-6 mb-15" }
const _hoisted_8 = { class: "card border-0 rounded-0 bg-primary text-white" }
const _hoisted_9 = { class: "card-body p-20" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "flex-grow-1 ms-15" }
const _hoisted_12 = { class: "mb-0 text-white" }
const _hoisted_13 = { class: "col-md-3 col-sm-6 mb-15" }
const _hoisted_14 = { class: "card border-0 rounded-0 bg-success text-white" }
const _hoisted_15 = { class: "card-body p-20" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "flex-grow-1 ms-15" }
const _hoisted_18 = { class: "mb-0 text-white" }
const _hoisted_19 = { class: "col-md-3 col-sm-6 mb-15" }
const _hoisted_20 = { class: "card border-0 rounded-0 bg-warning text-white" }
const _hoisted_21 = { class: "card-body p-20" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "flex-grow-1 ms-15" }
const _hoisted_24 = { class: "mb-0 text-white" }
const _hoisted_25 = { class: "col-md-3 col-sm-6 mb-15" }
const _hoisted_26 = { class: "card border-0 rounded-0 bg-info text-white" }
const _hoisted_27 = { class: "card-body p-20" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { class: "flex-grow-1 ms-15" }
const _hoisted_30 = { class: "mb-0 text-white" }
const _hoisted_31 = { class: "row mb-25" }
const _hoisted_32 = { class: "col-md-6 mb-15" }
const _hoisted_33 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_34 = { class: "card-body p-20" }
const _hoisted_35 = {
  ref: "agentChart",
  height: "300"
}
const _hoisted_36 = { class: "col-md-6 mb-15" }
const _hoisted_37 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_38 = { class: "card-body p-20" }
const _hoisted_39 = {
  ref: "dailyChart",
  height: "300"
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6 mb-15" }
const _hoisted_42 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_43 = { class: "card-body p-20" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_46 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_48 = { class: "col-md-6 mb-15" }
const _hoisted_49 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_50 = { class: "card-body p-20" }
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_53 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_54 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_55 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Dashboard Recensement")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshData())),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "flaticon-refresh position-relative ms-5 fs-12" }, null, -1),
              _createTextVNode(" Actualiser ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", _hoisted_4, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", {
                class: "spinner-grow spinner-grow-sm",
                role: "status",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "flaticon-users fs-30 text-white" })
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("h6", { class: "mb-5 text-white" }, "Total Recensements", -1)),
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.stats.totalRecensements || 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "flaticon-check fs-30 text-white" })
                ], -1)),
                _createElementVNode("div", _hoisted_17, [
                  _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "mb-5 text-white" }, "Recensements Existant", -1)),
                  _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.stats.recensementsExistant || 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "flaticon-plus fs-30 text-white" })
                ], -1)),
                _createElementVNode("div", _hoisted_23, [
                  _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "mb-5 text-white" }, "Recensements Nouveau", -1)),
                  _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.stats.recensementsNonExistant || 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "flaticon-search fs-30 text-white" })
                ], -1)),
                _createElementVNode("div", _hoisted_29, [
                  _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "mb-5 text-white" }, "Total Vérifications", -1)),
                  _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.stats.totalVerifications || 0), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header bg-transparent border-0 p-20" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Recensements par Agent")
            ], -1)),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("canvas", _hoisted_35, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header bg-transparent border-0 p-20" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Évolution des 7 derniers jours")
            ], -1)),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("canvas", _hoisted_39, null, 512)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header bg-transparent border-0 p-20" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Recensements par Agent")
            ], -1)),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("table", _hoisted_45, [
                  _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      }, " Agent "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      }, " Nombre ")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.recensementsParAgent, (agent, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_46, _toDisplayString(agent.agentNom) + " " + _toDisplayString(agent.agentPrenom), 1),
                        _createElementVNode("td", _hoisted_47, _toDisplayString(agent.nombreRecensements), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header bg-transparent border-0 p-20" }, [
              _createElementVNode("h6", { class: "mb-0" }, "Derniers Recensements")
            ], -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("table", _hoisted_52, [
                  _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      }, " Nom "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      }, " État "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      }, " Date ")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.derniersRecensements, (recensement, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_53, _toDisplayString(recensement.nom) + " " + _toDisplayString(recensement.prenom), 1),
                        _createElementVNode("td", _hoisted_54, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.getEtatBadgeClass(recensement.etatUsager)])
                          }, _toDisplayString(recensement.etatUsager), 3)
                        ]),
                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.format_date(recensement.createdAt)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}